import { object, string } from "zod";

export interface IFormPasswordProps {
  onSubmit: (password: string) => void;
  isLoading: boolean;
};

export interface IFormPassword {
  password: string;
};

export const formPasswordSchema = object({
  password: string({ required_error: "El campo contraseña es obligatorio" })
      .min(8, "La contraseña debe tener mas de 8 carácteres")
      .max(32, "La contraseña debe tener menos de 32 carácteres"),
  passwordConfirm: string({ required_error: "Por favor confirma la contraseña" })
}).refine((data) => data.password === data.passwordConfirm, {
  path: ["passwordConfirm"],
  message: "La contraseña no coincide",
})